import clsx from "clsx";
import { useMemo } from "react";

import { Select } from "@transfr-inc/dashboard-components/forms";

import { UserOptionItem } from "./user-option-item";

import "./user-select.scss";

/**
 * @param {object} props
 * @param {any[]} [props.selected]
 * @param {(selected: any[]) => void} [props.onChange]
 * @param {string} [props.placeholder]
 * @param {any[]} [props.data]
 * @param {string} [props.className]
 * @param {string} [props.ariaLabel] - When set, wraps the control in a labelled
 *   group so assistive tech can announce its purpose.
 * @param {boolean} [props.markArchived] - Marks archived users in their option
 *   label.
 */
export const UserSelect = ({
  selected,
  onChange,
  placeholder,
  data,
  className,
  ariaLabel,
  markArchived,
}) => {
  const options = useMemo(
    () => data?.map((user) => new UserOptionItem(user, { markArchived })),
    [data, markArchived]
  );

  const select = (
    <Select
      selected={selected}
      placeholder={placeholder}
      icon={["fa-light", "fa-magnifying-glass"]}
      onOptionsChange={onChange}
      className={clsx("user-select", className)}
      options={options}
      searchEnabled
    />
  );

  // Select renders a bare search input with no accessible name of its own.
  if (!ariaLabel) {
    return select;
  }

  return (
    <div role="group" aria-label={ariaLabel}>
      {select}
    </div>
  );
};
